import React from "react";
import { Handshake, Map, Search } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const advantages = [{
  title: "AI-Driven Attribution",
  description: "Deploying advanced neural networks to map every touchpoint in the customer journey, ensuring your marketing spend is optimized for maximum ROI.",
  icon: Handshake
}, {
  title: "Sentiment Mapping",
  description: "Real-time analysis of market discourse using natural language processing to pivot strategies before trends even hit the mainstream.",
  icon: Map
}, {
  title: "Benchmark Dashboard",
  description: "A high-fidelity command center providing a unified view of cross-channel performance metrics and competitive intelligence.",
  icon: Search
}];
export default function TheNeighborlyAdvantage() {
  return <section data-section-id="223484" id="our-core-capabilities" className="w-full bg-background text-foreground py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="rounded-3xl bg-secondary/30 backdrop-blur-sm border border-white/5 px-6 py-16 md:px-12 md:py-20 lg:px-16">
          <div className="mx-auto mb-16 max-w-2xl text-center">
            <h2 className="font-default text-3xl font-extrabold tracking-tighter text-foreground md:text-5xl uppercase">
              Our Core Capabilities
            </h2>
            <p className="mt-4 text-lg font-sans text-muted-foreground">
              Precision-engineered strategies designed to outperform competitors in dynamic global markets.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {advantages.map((item, i) => {
            const Icon = item.icon;
            return <Card key={i} data-index={i} className="group border border-white/10 bg-white/5 shadow-2xl transition-all duration-500 hover:border-primary hover:bg-white/10 rounded-sm">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-sm bg-primary/10 text-primary transition-transform duration-500 ease-out group-hover:scale-110">
                      <Icon className="h-8 w-8 stroke-[1.5]" />
                    </div>
                    <CardTitle className="font-default text-2xl font-bold tracking-tight text-foreground">
                      <h3>{item.title}</h3>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="leading-relaxed font-mono text-sm text-muted-foreground">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}